<template>
    <v-card style="direction: rtl">
        <v-toolbar
            dark
            elevation="0"
            color="primary"
        >
            <v-toolbar-title class="headline pb-0">{{dataToUse.Shipping_Street}} {{dataToUse.House_Number}},
                {{dataToUse.Shipping_City}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn
                icon
                dark
                @click.prevent="closeModal()"
            >
                <v-icon>fas fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="popup-wrapper">
            <v-card-subtitle class="ma-0 pb-0">כניסה:
                <span v-if="dataToUse.Entrance_Number">{{dataToUse.Entrance_Number}}</span>
                <span v-else>לא צויין</span>
            </v-card-subtitle>
            <v-card-subtitle class="ma-0 pb-0">קומה:
                <span v-if="dataToUse.Floor">{{dataToUse.Floor}}</span>
                <span v-else>לא צויין</span>
            </v-card-subtitle>
            <v-card-subtitle class="ma-0 ">דירה:
                <span v-if="dataToUse.Appartment"> {{dataToUse.Appartment}}</span>
                <span v-else>לא צויין</span>
            </v-card-subtitle>
            <!--        <v-card-text>{{dataToUse.Address_Notes}}</v-card-text>-->
            <v-card-subtitle class="font-weight-bold">
                {{dataToUse.Deal_Name}}
                <span v-for="tag in tags" v-if="tag.name === 'תלונה על משלוחים'" :key="tag + '_tag'"
                      class="singleTag error--text">
                <v-icon class="me-2" color="error">far fa-angry</v-icon> לקוח בעייתי
            </span>
            </v-card-subtitle>
            <v-card-text>{{dataToUse.Shipment_Notes}}</v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="4">
                        <v-btn color="#79d1e9"
                               :large="true"
                               outlined
                               :depressed="true"
                               @click.prevent="goToWaze(dataToUse.Latitude, dataToUse.Longitude, dataToUse.Shipping_Street, dataToUse.House_Number, dataToUse.Shipping_City)"
                               :block="true">
                            <v-icon>fab fa-waze</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="#25D366"
                               :large="true"
                               :depressed="true"
                               outlined
                               @click.prevent="goToWhatsapp(dataToUse.Receiver_Phone)"
                               :block="true">
                            <v-icon>fab fa-whatsapp</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" style="display: none">
                        <v-file-input
                            :ref="'uploadImage'"
                            :id="'uploadImage'"
                            @change="handleImage"
                            class="imgToSend"
                            v-model="imgToSend"
                            accept="image/*"
                            :prepend-icon="''"
                            capture="camera"></v-file-input>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="primary"
                               :large="true"
                               :depressed="true"
                               @click="uploadImage"
                               :block="true">
                            <v-icon v-if="!imageUploaded">fas fa-camera-retro</v-icon>
                            <v-icon v-else>fas fa-exchange-alt</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="imageUploaded">
                        <v-img
                            :max-width="'600px'"
                            :width="'100%'"
                            :src="imageUrl"></v-img>
                    </v-col>
                    <v-col cols="12" v-if="imageUploaded">
                        <v-btn color="error"
                               :large="true"
                               :depressed="true"
                               outlined
                               @click="removeImage"
                               :block="true">
                            <v-spacer></v-spacer>
                            הסרת תמונה
                            <v-spacer></v-spacer>
                            <v-icon :right="true">far fa-trash-alt</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-products-panel v-observe-visibility="getProducts" :products="products"></v-products-panel>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="radios" :mandatory="true">
                            <v-radio label="המשלוח התקבל" value="true"></v-radio>
                            <v-radio label="המשלוח לא התקבל" value="false"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            outlined
                            name="input-7-4"
                            label="הערות"
                            value=""
                            rows="3"
                            no-resize
                            v-model="notes"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-row>
                            <v-expansion-panels
                                :accordion=true
                                :tile=true
                            >
                                <v-expansion-panel>
                                    <v-expansion-panel-header>חתימה</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-col cols="12">
                                            <VueSignaturePad
                                                id="signature"
                                                width="100%"
                                                :options="signOptions"
                                                height="160px" ref="signaturePad"
                                                class="signaturePad"/>
                                        </v-col>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-btn color="#ffd632"
                               :x-large="true"
                               :depressed="true"
                               class="sendButton"
                               @click.prevent="submitStatus(dataToUse)"
                               :block="true">
                            <v-spacer></v-spacer>
                            שלח
                            <v-spacer></v-spacer>
                            <v-icon :right="true">fas fa-fish</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="primary"
                               :large="true"
                               outlined
                               :depressed="true"
                               @click.prevent="goToPhone(dataToUse.Receiver_Phone)"
                               :block="true">
                            <v-icon>fas fa-phone</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="error"
                               :large="true"
                               :depressed="true"
                               :disabled="bt_WrongAddress_State"
                               @click="submitWrongAddress(dataToUse)"
                               outlined
                               :block="true">
                            <v-icon>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="error"
                               outlined
                               :large="true"
                               :depressed="true"
                               :disabled="isAngryClient"
                               @click.prevent="submitAngryCustomer(dataToUse)"
                               :block="true">
                            <v-icon>far fa-angry</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn color="black"
                               class="white--text"
                               :depressed="true"
                               @click.prevent="closeModal()"
                               :large="true"
                               :block="true">
                            סגירה
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-overlay :value="innerOverlay" class="overlayLoader">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card-text>
    </v-card>
</template>

<script>
    import {HTTP} from '../http/http-common.js';
    import VProductsPanel from "./vProductsPanel";

    export default {
        name: "vPopup",
        components: {
            VProductsPanel
        },
        props: ['dataToUse', 'popupShown'],
        data() {
            return {
                products: false,
                innerOverlay: false,
                imgToSend: null,
                imageName: null,
                imageUrl: null,
                imageFile: null,
                imageUploaded: false,
                bt_WrongAddress_State: false,
                signOptions: {
                    dotSize: (0.5 + 2.5) / 2,
                    minWidth: 0.5,
                    maxWidth: 2.5,
                    throttle: 16,
                    minDistance: 5,
                    backgroundColor: 'rgba(0,0,0,0)',
                    penColor: 'black',
                    velocityFilterWeight: 0.7,
                    tag: process.env.VUE_APP_TAG_REPORT_CUSTOMER,
                    onBegin: () => this.onBegin(),
                    onEnd: () => this.onEnd()
                },
                radios: true,
                notes: '',
                tags: '',
            }
        },
        created() {

        },
        mounted() {
            console.log(this.dataToUse)
            this.radios = true;
            this.reset();
        },
        watch: {
            display: function (value) {
                this.displayDialog = value;
                this.$nextTick(function () {
                    this.imageUrl = null;
                    this.$refs.signaturePad.resizeCanvas();
                    this.$refs.signaturePad.fromDataURL(this.editedItem._signature);
                })
            }
        },
        computed: {
            isAngryClient() {
                let status = false;
                let self = this;
                this.dataToUse.Tags.forEach(function (tag) {
                    if (tag.name === "תלונה על משלוחים") {
                        status = true;
                    }
                })
                return status
            },
        },
        methods: {
            getProducts: function () {
                let self = this;
                if (!this.products) {
                    this.reset();
                    HTTP.get('getProducts/' + this.dataToUse.id).then(function (resp) {
                        console.log(resp);
                        self.products = resp;
                    })
                        .catch(function (error) {
                            let data = {
                                text: 'שגיאה בקבלת מוצרים',
                                status: 'error'
                            }
                            self.$emit('showSnackbar', data);
                            self.products = false;
                        });
                }

            },
            resetWrongAddressButton: function () {
                this.bt_WrongAddress_State = false;
            },
            resetSignature: function () {
                this.removeImage();
                //check if clearSignature in scope
                if (typeof this.$refs.signaturePad !== "undefined") {
                    // safe to use the function
                    this.$refs.signaturePad.clearSignature();
                }
                this.notes = '';
                // this.$refs.signaturePad.resizeCanvas();
                this.products = false;
            },
            onBegin: function () {
                console.log('=== Begin ===');
                this.$refs.signaturePad.resizeCanvas();
            },
            onEnd: function () {
                console.log('=== End ===');
            },
            goToWhatsapp: function (phone) {
                let phoneToUse = phone.replace('0', '972')
                window.open('https://api.whatsapp.com/send?phone=' + phoneToUse + '&text=שלום שליח אומגה 3 גליל צפוי להגיע בשעה- שעתיים הקרובות. נשמח שתהיו זמינים לקבלת המשלוח. תודה')
            },
            goToPhone: function (phone) {
                // let phoneToUse = phone.replace('0', '972')
                window.open('tel:' + phone)
            },
            goToWaze: function (lat, lng, address, number, city) {
                // window.open('https://waze.com/ul?q=' + number + ' ' + address + ', ' + city + '&ll=' + lat + ',' + lng + '&navigate=yes')
                // window.open('waze://?ll='+ lat +','+ lng +'&navigate=yes')
                window.open('https://waze.com/ul?q=' + number + ' ' + address + ', ' + city + '&navigate=yes')
            },
            goToMaps: function (address, number, city) {
                window.open('http://maps.google.com/maps?saddr=Current%20Location&daddr=' + city + ', ' + address + ' ' + number)
            },
            reset() {
                this.innerOverlay = false;
                this.radios = true;
                this.removeImage()
                this.resetSignature()
                this.resetWrongAddressButton()
                this.getContactTags()
                this.products = false;
            },
            closeModal: function () {
                this.$emit('closeModal')
                this.products = false;
                this.reset()
            },
            getContactTags: function () {
                this.tags = null;
                let self = this;
                let url = 'getContactTags/' + this.dataToUse.Contact_Name.id
                console.log(url);
                HTTP.get(url).then(function (resp) {
                    self.tags = resp
                })
                    .catch(function (resp) {
                        let data = {
                            text: 'שגיאה בקבלת תגיות',
                            status: 'error'
                        }
                        self.$emit('showSnackbar', data);
                        console.log(resp);
                    });
            },
            submitAngryCustomer: function (point) {
                let self = this;
                let data = {
                    "tag": "תלונה על משלוחים"
                }
                self.$emit('showLoader');
                HTTP.post('set_contact_tag/' + point.Contact_Name.id, data).then(function (resp) {

                    let data = {
                        text: 'דיווח לקוח בעייתי נשמר בהצלחה',
                        status: 'success'
                    }
                    self.$emit('showSnackbar', data);
                })
                    .catch(function (resp) {
                        let data = {
                            text: 'שגיאה בדיווח לקוח בעייתי',
                            status: 'error'
                        };
                        self.$emit('showSnackbar', data);
                        console.log(resp);
                    });
            },
            submitWrongAddress: function (point) {
                let self = this;
                let data = {
                    potentialID: point.id,
                    address: point.Shipping_Street,
                    city: point.Shipping_City,
                    house_number: point.House_Number,
                    latitude: self.dataToUse.Latitude,
                    longitude: self.dataToUse.Longitude
                }
                self.$emit('showLoader');
                HTTP.post('reportAddress', data).then(function (resp) {
                    let data = {
                        text: 'דיווח כתובת שגויה נשמר בהצלחה',
                        status: 'success'
                    }
                    self.bt_WrongAddress_State = true;
                    self.$emit('showSnackbar', data);
                })
                    .catch(function (resp) {
                        let data = {
                            text: 'שגיאה בדיווח כתובת שגויה',
                            status: 'error'
                        }
                        self.$emit('showSnackbar', data);
                        console.log(resp);
                    });
            },
            submitStatus: function (point) {
                let self = this;
                /** Check if the signature is exsists */
                    // if(!this.$refs.signaturePad) {
                    //     let data = {
                    //         text: 'נא לחתום בבקשה',
                    //         status: 'error'
                    //     }
                    //     self.$emit('showSnackbar', data);
                    // }
                let data = {
                        "note": this.notes,
                        "delivered": this.radios,
                        "image": this.imageUrl,
                    }
                if (this.$refs.signaturePad && !this.$refs.signaturePad.isEmpty()) {
                    data['signature'] = this.$refs.signaturePad.saveSignature("image/jpeg")
                }
                this.innerOverlay = true;
                self.$emit('showLoader');
                /** Post data **/
                HTTP.post('set_deal_status/' + point.id, data).then(function (resp) {
                    let data = {
                        text: 'עדכון משלוח נשמר בהצלחה',
                        status: 'success'
                    }
                    //if we failed to send sms
                    if(resp["sms"] === false) {
                        data.text += " שים לב לא נשלח SMS";
                        data.status = "warning";
                    }
                    self.$emit('showSnackbar', data);
                    //end
                    self.$emit('successSubmit', point);
                    self.resetSignature()

                })
                    .catch(function (resp) {
                        let data = {
                            text: 'שגיאה בעדכון סטטוס משלוח',
                            status: 'error'
                        }
                        self.$emit('showSnackbar', data);
                        self.resetSignature()
                        console.log(resp);
                    });

            },
            handleImage: function (e) {
                let self = this;
                const files = e;
                if (files !== undefined) {
                    let reader = new FileReader();
                    reader.onload = function (readerEvent) {
                        let image = new Image();
                        image.onload = function (imageEvent) {
                            // Resize the image
                            let canvas = document.createElement('canvas'),
                                max_size = 600,
                                width = image.width,
                                height = image.height;
                            if (width > height) {
                                if (width > max_size) {
                                    height *= max_size / width;
                                    width = max_size;
                                }
                            } else {
                                if (height > max_size) {
                                    width *= max_size / height;
                                    height = max_size;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                            let dataUrl = canvas.toDataURL('image/jpeg', .6);
                            let resizedImage = self.dataURLToBlob(dataUrl);
                            let file = new File([resizedImage], files.name, {
                                type: "image/jpeg",
                                lastModified: Date.now()
                            });
                            resizedImage.lastModifiedDate = new Date();
                            resizedImage.name = files.name;
                            self.imageName = files.name
                            self.imageUrl = dataUrl;
                            self.imageFile = dataUrl; // this is an image file that can be sent to server...
                            self.imageUploaded = true;
                            let data = {
                                image: self.imageFile,
                                index: self.index - 1
                            }
                            self.$emit('saveImageToMission', data)

                        }
                        image.src = readerEvent.target.result;
                    }
                    reader.readAsDataURL(files);
                } else {
                    self.imageName = '';
                    self.imageFile = '';
                    self.imageUrl = '';
                    self.imageUploaded = false;
                }
            },
            dataURLToBlob: function (dataURL) {
                let BASE64_MARKER = ';base64,';
                if (dataURL.indexOf(BASE64_MARKER) == -1) {
                    let parts = dataURL.split(',');
                    let contentType = parts[0].split(':')[1];
                    let raw = parts[1];

                    return new Blob([raw], {type: contentType});
                }

                let parts = dataURL.split(BASE64_MARKER);
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }

                return new Blob([uInt8Array], {type: contentType});
            },
            uploadImage: function () {
                document.getElementById('uploadImage').click();
            },
            removeImage: function () {
                this.imageName = '';
                this.imageFile = '';
                this.imageUrl = '';
                this.imageUploaded = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .imgToSend {
        display: none;
    }

    span.singleTag {
        padding: 5px 15px;
        display: inline-block;
        margin-left: 5px;
        margin-bottom: 5px;
        border-radius: 50px;
        float: left;
    }

    .v-card__text.popup-wrapper {
        max-height: 80vh;
        overflow: scroll;
    }

    .v-card__subtitle {
        padding: 0;
    }

    .v-dialog > .v-card > .v-card__subtitle,
    .v-dialog > .v-card > .v-card__text {
        padding: 1em;
    }
</style>
